import { createContext } from 'react';

export const reviewsContext = createContext({});

export default reviewsContext;
